import { render, staticRenderFns } from "./SubscribeList.vue?vue&type=template&id=b55b572c&scoped=true&"
import script from "./SubscribeList.vue?vue&type=script&lang=js&"
export * from "./SubscribeList.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeList.vue?vue&type=style&index=0&id=b55b572c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55b572c",
  null
  
)

export default component.exports